module.exports = __webpack_public_path__ + "img/logo_new_altium_png.4a36f628.png";